import { Item } from "./types";
import type { InstagramFeedItem } from "./utils/instagramFeed";

export type InstagramFeedPayload = {
  items: InstagramFeedItem[];
  /** Backend sets true only when INSTAGRAM_USER_ID is configured */
  sectionVisible: boolean;
};

export const fetchInstagramFeed = (): Promise<InstagramFeedPayload> =>
  fetch(`${process.env.REACT_APP_BASE_URL}/instagram-feed`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    redirect: "follow",
    cache: "no-store",
  })
    .then((response) => response.json())
    .then((data: { items?: unknown; sectionVisible?: boolean }) => {
      const raw = data?.items;
      const items = !Array.isArray(raw)
        ? []
        : raw
            .filter(
              (x): x is Record<string, unknown> =>
                Boolean(x) && typeof x === "object"
            )
            .map((x) => ({
              src: typeof x.src === "string" ? x.src : "",
              href: typeof x.href === "string" ? x.href : "",
            }))
            .filter((x) => x.src.length > 0 && x.href.length > 0)
            .slice(0, 6);
      return {
        items,
        sectionVisible: data?.sectionVisible === true,
      };
    })
    .catch(() => ({ items: [], sectionVisible: true }));

export const fetchProducts = () =>
  fetch(`${process.env.REACT_APP_BASE_URL}/products`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
  })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`Products request failed: ${response.status}`);
      }
      return response.json();
    })
    .catch((error) => {
      console.log("error", error);
      throw error;
    });

const API_KEY = process.env.REACT_APP_API_KEY

export const createProduct = (newProduct: { name: string, description: string, priceYouth: string, priceAdult: string }, images: string[], variations: Item[]) => fetch(`${process.env.REACT_APP_BASE_URL}/admin/products`, {
    method: 'POST',
    headers: {
        "x-api-key": API_KEY || "",
        "Content-Type": "application/json",
    },
    body: JSON.stringify({ name: newProduct.name, description: newProduct.description, priceYouth: newProduct.priceYouth, priceAdult: newProduct.priceAdult, images, variations }),
    redirect: 'follow'
  })
  .then(response => response.json())
  .catch(error => console.log('error', error));

export const deleteProduct = (id: string) => fetch(`${process.env.REACT_APP_BASE_URL}/admin/products/${id}`, {
    method: 'DELETE',
    headers: {
        "x-api-key": API_KEY || "",
        "Content-Type": "application/json",
    },
    redirect: 'follow'
  })
  .then(response => response.json())
  .catch(error => console.log('error', error));

export const zeroAllProductInventory = (): Promise<{ ok: boolean; productsUpdated: number }> =>
  fetch(`${process.env.REACT_APP_BASE_URL}/admin/clear-all-product-inventory`, {
    method: "POST",
    headers: {
      "x-api-key": API_KEY || "",
      "Content-Type": "application/json",
    },
    redirect: "follow",
  }).then(async (response) => {
    const data = (await response.json().catch(() => ({}))) as {
      error?: string;
      ok?: boolean;
      productsUpdated?: number;
    };
    if (!response.ok) {
      throw new Error(data.error || "Failed to clear inventory");
    }
    return {
      ok: Boolean(data.ok),
      productsUpdated: Number(data.productsUpdated ?? 0),
    };
  });

export const updateProduct = (id: string, updatedProduct: { name: string, description: string, priceYouth: string, priceAdult: string }, images: string[], variations: Item[]) => fetch(`${process.env.REACT_APP_BASE_URL}/admin/products/${id}`, {
    method: 'PATCH',
    headers: {
        "x-api-key": API_KEY || "",
        "Content-Type": "application/json",
    },
    body: JSON.stringify({ name: updatedProduct.name, description: updatedProduct.description, priceYouth: updatedProduct.priceYouth, priceAdult: updatedProduct.priceAdult, images, variations }),
    redirect: 'follow'
})
.then(response => response.json())
.catch(error => console.log('error', error));
